import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';
import { rewrapRefreshTokenIfRotated } from 'utils/helpers/pinSessionKey.helpers';
import axiosInstance, { axiosInstanceSaviPinOprf, axiosInstanceSADL } from 'services/APIService';

const INTERCEPTORS = [
  { instance: axiosInstance, interceptorId: 0 },
  { instance: axiosInstanceSADL, interceptorId: 0 },
  { instance: axiosInstanceSaviPinOprf, interceptorId: 0 },
];

export const useAuthenticationInterceptor = (): void => {
  const { getAccessTokenSilently } = useAuth0();

  useEffect(() => {
    INTERCEPTORS.forEach(config => {
      config.interceptorId = config.instance.interceptors.request.use(
        async config => {
          // the PIN endpoints are deliberately unauthenticated (see PepperSignerService): PIN login is
          //  what creates a session, so a logged-out user has no token to send.
          if (config.url?.endsWith('/pin/public-key') || config.url?.endsWith('/pin/pepper')) {
            return config;
          }

          const token = await getAccessTokenSilently();
          await rewrapRefreshTokenIfRotated();

          config.headers.set('Authorization', `Bearer ${token}`);

          return config;
        },
        error => {
          return Promise.reject(error);
        },
      );
    });
  }, [getAccessTokenSilently]);
};
